import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CustomDragAndDrop } from '../../common/commonComponents';
import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg"
import { ReactComponent as DownloadIcon } from "assets/img/svg/download.svg"
import AButton from '../../common/form-fields-mui/AButton';
import { Card, CardBody } from "reactstrap";
import { FaInfoCircle } from "react-icons/fa";
import { failureToast, successToast } from '../../common/utils/methods/toasterFunctions/function';
import { uploadpost } from 'services/utils';
import { putpost } from 'services/utils';
import { endpoint } from '../../common/constant';
import { getUniqueKey } from '../../common/utils/methods/commonMethods/utilityMethod';
import { downLoadFile } from '../../masters/studentFinancials/paymentCollection/bulkCollection/utils';
import { TEMPLATE_NAME } from './constant';
import { getDownloadTemplateUrl } from './apis';
const ExcelFileRequirements = ({downloadHandler}) => {
    return (
        <div
            style={{
                backgroundColor: "#F5F9FF",   // soft blue background
                border: "1px solid #CFE3FF", // subtle blue border
                borderRadius: "6px",
                padding: "16px 20px",
                marginTop: "20px",
            }}
        >
            {/* Header */}
            <div className="d-flex align-items-center mb-2">
                <FaInfoCircle size={16} color="#2563EB" style={{ marginRight: "6px" }} />
                <span
                    style={{
                        fontSize: "15px",
                        fontWeight: 600,
                        color: "#2563EB", // blue header
                    }}
                >
                    Excel File Format Requirements:
                </span>
            </div>

            {/* Requirements list */}
            <ul
                style={{
                    marginLeft: '14px',
                    paddingLeft: "20px", // proper bullet indent
                    fontSize: "13px",
                    lineHeight: "1.75",
                    color: "#1F2937", // dark grey text
                    listStyleType: "disc",
                }}
            >
                <li style={{ color: "#2563EB" }}>
                    <span style={{ color: "#6995f4ff" }}>
                        Column headers:{" "}

                        Business Area, Course Category, Term, Academic Group, Carrier,
                        Amount
                    </span>
                </li>
                <li style={{ color: "#2563EB" }}>
                    <span style={{ color: "#6995f4ff" }}>
                        All fields are mandatory except Academic Group and Carrier
                    </span>
                </li>
                <li style={{ color: "#2563EB" }}>
                    <span style={{ color: "#6995f4ff" }}>Amount should be in numeric format</span>
                </li>
                <li style={{ color: "#2563EB" }}>
                    <span style={{ color: "#6995f4ff" }}>
                        First row should contain column headers
                    </span>
                </li>
                <li style={{ color: "#2563EB" }}>
                    <span style={{ color: "#6995f4ff" }}>
                        <span
                        className='cursor'
                            onClick={()=>downloadHandler()}
                            style={{
                                color: "#2563EB", // bright blue link
                                fontWeight: 600,
                                textDecoration: 'underline'
                                
                            }}
                        >
                            Download the template file
                        </span>{" "}
                        for reference
                    </span>
                </li>
            </ul>
        </div>
    );
};

    
const CustomBulkUploadDialog = ({
    handleClose,
    isBulkOpen,
    handleFile,
    files,
    setFiles,
    progressBarStatus,
    setProgressBarStatus,
    searchArpuList,
    processTagId
}) => {
    const [isUploading, setIsUploading] = useState(false);

    const getFilePath = () => {
    try {
    //   setConfimation(false);
      setIsUploading(true);
      // alert(isUploading)
      if (!files) {
        failureToast("Please Select File");
        return;
      }
    const dataToServer = {
    bulk: true,
    fileName: files?.name,
    docType: files?.type,
    keyValue: `${TEMPLATE_NAME}_${getUniqueKey()}`,
    serviceName: TEMPLATE_NAME,
  };
      setIsUploading(true);
      const formData = {
        ...dataToServer,
      };

      putpost(endpoint.fetchS3Url.getUrl,
        // `${documentServiceBaseUrl}/documentManagement/getUploadUrl`,
        (data) => {
          if (data.code === 200 && data.data) {
            saveDataToStorage(data.data);
            setProgressBarStatus(15);
          }
        },
        (data) => {
          setProgressBarStatus(0);
          setIsUploading(false);
          failureToast(data["message"]);
        },
        formData,
        "post"
      );
    } catch (e) {
      console.log(e);
    }
  };

  //this is file uploadImage part
  const saveDataToStorage = (res) => {
    try {
      const formData = new FormData();
      formData.append("File", files);
      // formData.append("destinationfolder", res.bucket);
      setProgressBarStatus(30);
      uploadpost(
        res.storage,
        (data) => {
          saveHandler({
            ...res,
            files
          });
          setProgressBarStatus(45);
          // successToast(data["message"]);
        },
        (data) => {
          setProgressBarStatus(0);
          setIsUploading(false);
          failureToast("Unable to upload file, please try after sometime.");
        },
        files,
        files?.type,
        files?.name
      );
    } catch (e) {
      setProgressBarStatus(0);
      setIsUploading(false);
      failureToast("Unable to upload file, please try after sometime.");
      console.log(e);
    }
  };
  const saveHandler = (data) => {
    const request = {
      isProcess: true,
      processType: TEMPLATE_NAME,
      serviceName: TEMPLATE_NAME,
      processId: data.processId,
      status: "SUCCESS",
      documentType: data?.files?.type,
      extId: data.processId,
      signedUrl: data.processId,
      processTagTypeId: processTagId,
    };

    putpost(
      endpoint.fetchS3Url.commonUploadDms,
      (res) => {
        if (res.code === 200 && res.data) {
          setProgressBarStatus(100);
          successToast("Requet Completed Successfully !!!")
          searchArpuList({})
        }
      },
      (res) => {
        setIsUploading(false);
        setProgressBarStatus(0);
        failureToast(res["message"]);
      },
      request,
      "post"
    );
  };
  useEffect(() => {
  if (progressBarStatus === 100) {
    handleClose();
  }
}, [progressBarStatus]);
  const downloadHandler = async () => {
    const res = await getDownloadTemplateUrl(TEMPLATE_NAME)
    console.log(res, 'download')
    await downLoadFile(res?.['Template Url'])
  }


    return (
        <Dialog onClose={handleClose}
            open={isBulkOpen}
            fullWidth
            maxWidth="md"
        >
            <div className='p-3'>
                <div className='d-flex justify-content-between mb-4'>
                    <div className='large-text'>Bulk Upload Excel File</div>
                    <div className='d-flex justify-content-between' style={{ gap: '8px' }}>
                        <AButton
                            className="tiny-semi-bold color-dark"
                            onClick={() => {downloadHandler({}) }}
                            size="xs"
                            updatedStyle={{
                                minWidth: "61px",
                            }}
                            variant="primary_filled"
                        >
                            <DownloadIcon className='mr-1' />  Download Template
                        </AButton>
                        <CloseIcon onClick={handleClose} />
                    </div>
                </div>
                <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                <div className='regular-large-bold mb-2 mt-4'>Upload Excel File</div>
                <CustomDragAndDrop
                    setFile={setFiles}
                    //validFiles={['.csv']}
                    message={'Please select excel file only'}
                    name={'File'}
                    handleFile={handleFile}
                    isUploading={isUploading}
                    progressBarStatus={progressBarStatus}
                    isIcon={true}
                    updatedStyle={{ height: '150px' }}
                    isAddButtonRequired={false}
                    fileDescription="Drag and drop your Excel file here, or click to browse"
                    isCardNeeded={false}
                    files={files}
                    maxUploadFileSize={2}
                    fileNameValidation
                />
                <ExcelFileRequirements downloadHandler={downloadHandler} />
                <div className='d-flex justify-content-end mt-4'>
                    <AButton 
                    variant='general'
                    onClick={handleClose}
                    >
                        Cancel
                    </AButton>
                    <AButton
                        disabled={!files}
                        variant='primary_filled'
                        className="ms-2" // gap between buttons
                        onClick={()=>{getFilePath()}}
                    >
                        Upload File
                    </AButton>
                </div>

            </div>
        </Dialog>
    )
}

export default CustomBulkUploadDialog